import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { color } from '@mui/system'
import { FONTS, SPACES } from 'src/constants'

interface IStyleProps {
  isRound?: boolean
  fullWidth?: boolean
  showAccountInfo?: boolean
}

export const useStyles = makeStyles((theme: Theme) => ({
  listWrapper: ({ fullWidth }) => ({
    '&&': {
      width: '100%',
      height: '100%',
      scrollbarWidth: 'none',

      paddingBottom: 0,

      display: 'flex',
      gap: SPACES.xs,

      overflowX: 'scroll',
      overflow: 'auto',

      '&::-webkit-scrollbar': {
        width: 0,
      },

      [theme.breakpoints.down('tablet')]: {
        flexDirection: 'column',
        height: '100%',
      },

      [theme.breakpoints.up('tablet')]: {
        flexDirection: fullWidth ? 'column' : 'row',
        height: fullWidth ? '100%' : 'auto',
        flexWrap: fullWidth ? 'nowrap' : 'wrap',
      },
    },
  }),
  item: ({ isRound, fullWidth, showAccountInfo }: IStyleProps) => ({
    '&&': {
      position: 'relative',
      display: 'flex',
      gap: isRound ? SPACES.xxl : SPACES.xs,
      alignItems: 'center',

      borderRadius: 15,
      padding: SPACES.xs,
      height: 'auto',

      // [theme.breakpoints.down('tablet')]: {
      //   height: 70,
      // },

      [theme.breakpoints.up('tablet')]: {
        minHeight: !showAccountInfo ? 80 : 'none',
        width: fullWidth ? '100%' : 300,
      },
    },
  }),
  icon: ({ isRound }: IStyleProps) => ({
    '&&': {
      justifySelf: 'left',
      borderRadius: isRound ? '50%' : 5,
      objectFit: 'cover',

      [theme.breakpoints.down('tablet')]: {
        width: 50,
        height: 50,
      },
      [theme.breakpoints.up('tablet')]: {
        width: 60,
        height: 60,
      },
    },
  }),
  title: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.bold,

      // overflow: 'hidden',
      // textOverflow: 'ellipsis',
      // whiteSpace: 'nowrap',

      [theme.breakpoints.down('tablet')]: {
        maxWidth: 'calc(100vw - 160px)',
      },
      [theme.breakpoints.up('tablet')]: {
        // maxWidth: 208,
      },
    },
  },
  locationName: {
    '&&': {
      fontSize: '12px',
      [theme.breakpoints.down('tablet')]: {
        maxWidth: 'calc(100vw - 160px)',
      },
      [theme.breakpoints.up('tablet')]: {
        // maxWidth: 208,
      },
    },
  },
  subtitle: {
    '&&': {
      fontSize: FONTS.SIZES.s,
      display: 'block',

      // overflow: 'hidden',
      // textOverflow: 'ellipsis',
      // whiteSpace: 'nowrap',

      [theme.breakpoints.down('tablet')]: {
        maxWidth: 'calc(100vw - 160px)',
      },
      [theme.breakpoints.up('tablet')]: {
        // maxWidth: 208,
      },
    },
  },
  borderActive: {
    '&&': {
      backgroundColor: theme.palette.custom.grey,
      border: `1px solid ${theme.palette.custom.grey2}`,
    },
  },

  bgAiGenerated: {
    '&&': {
      backgroundColor: theme.palette.custom.lightGreen,
    },
  },

  borderActiveAiGenerated: {
    '&&': {
      backgroundColor: theme.palette.custom.lightGreen,
      border: `1px solid green`,
    },
  },
  borderInactive: {
    '&&': {
      border: `1px solid ${theme.palette.custom.grey}`,
    },
  },
}))
